import $axiosProtected from '../../common/utils/axiosUtils';

// Get Patient Consultation Details by Facility Code
export const generateAgoraToken = async (payload: any) => {
    return await $axiosProtected().post(`/scheduler/agora/token`, payload);
};
